import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { me } from "@/lib/admin-api";

export default function ProtectedAdmin({ children }) {
    const [state, setState] = useState({ loading: true, ok: false });

    useEffect(() => {
        let alive = true;
        const token = localStorage.getItem("admin_token");
        if (!token) {
            setState({ loading: false, ok: false });
            return;
        }
        me()
            .then((u) => {
                if (alive) {
                    localStorage.setItem("admin_user", JSON.stringify(u));
                    setState({ loading: false, ok: true });
                }
            })
            .catch(() => alive && setState({ loading: false, ok: false }));
        return () => {
            alive = false;
        };
    }, []);

    if (state.loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="w-8 h-8 border-2 border-eclipse-cta border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }
    if (!state.ok) return <Navigate to="/admin/login" replace />;
    return children;
}
